import React, { Component, Fragment } from "react";
import TopNavigation from "../../Components/Common/TopNavigation";
import Footer from "../../Components/Common/Footer";
import Otp from "../../Components/OTP/OTP";
class OtpPage extends Component {
  componentDidMount() {
    window.scroll(0, 0);
  }
  render() {
    return (
      <Fragment>
        <TopNavigation />
        <div className="responsive-padding-top">
          <Otp />
        </div>
        <Footer />
      </Fragment>
    );
  }
}

export default OtpPage;
